/**
 * Optional institution association on workflow steps (Story 3.2 / ACME-1406).
 * Outbound save uses PascalCase InstitutionUuid; omit when empty (Story 3.1 rejects whitespace-only).
 */

export function readInstitutionUuidFromStep(step: Record<string, unknown> | null | undefined): string {
  if (step == null) return "";
  const raw = step.institutionUuid ?? step.InstitutionUuid;
  return raw != null ? String(raw).trim() : "";
}

export function applyInstitutionUuidOutbound(
  workflowStep: Record<string, unknown>,
  institutionUuid: string | null | undefined
): void {
  delete workflowStep.institutionUuid;
  const uuid = institutionUuid?.trim();
  if (uuid) {
    workflowStep.InstitutionUuid = uuid;
  } else {
    delete workflowStep.InstitutionUuid;
  }
}
